import { http_client } from '../../util/http_client';
import { AI_SEARCH_API_BASE_URL } from './constants';

export type AISummaryData = Record<string, any>;

interface BookChapterParams {
  bookId: string | number;
  editionId: string | number;
  chapterId: string | number;
}

interface PeriodicItemParams {
  periodicId: string | number;
  editionId: string | number;
  itemId: string | number;
}

const summary_url = `${AI_SEARCH_API_BASE_URL}/document-summary`;

export function getBookChapterSummary({
  bookId,
  editionId,
  chapterId
}: BookChapterParams) {
  return http_client
    .get<AISummaryData>(summary_url, {
      book_id: String(bookId),
      edition_id: String(editionId),
      chapter_id: String(chapterId)
    })
    .then((r) => r.data);
}

export function getPeriodicItemSummary({
  periodicId,
  editionId,
  itemId
}: PeriodicItemParams) {
  return http_client
    .get<AISummaryData>(summary_url, {
      periodic_id: String(periodicId),
      edition_id: String(editionId),
      item_id: String(itemId)
    })
    .then((r) => r.data);
}
